import React, { useState } from "react";
import "./Register.css"; // Import the CSS file for styling
import { useNavigate } from "react-router-dom";

const Resetpw = () => {
  const [formData, setFormData] = useState({
    username: "", // Add username field
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { username, password, confirmPassword } = formData;

    if (!username || !password || !confirmPassword) {
      setError("All fields are required!");
      setSuccess("");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match!");
      setSuccess("");
      return;
    }

    try {
      const response = await fetch("https://pyate-backend-production-db97.up.railway.app/user/resetpw_api", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password, confirmPassword }), // Include username in the request
      });

      const data = await response.json();

      if (response.ok) {
        setError("");
        setSuccess(data.message || "Password reset successfully!");
        setTimeout(() => navigate("/"), 1000); // Redirect to Forgot Password page after 2 seconds
      } else {
        setError(data.error || "Reset failed!");
        setSuccess("");
      }
    } catch (err) {
      setError("Unable to connect to the server. Please try again later.");
      setSuccess("");
    }
  };

  return (
    <div className="register-container">
      <div className="register-wrapper">
        <h2 className="register-header">Reset Password</h2>
        <p>Enter a new password below to change your password</p>
        <form onSubmit={handleSubmit} className="register-form">
          <div className="input-group">
            <label htmlFor="username">Username:</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">New Password:</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter new password"
              />
              <span
                className="toggle-password"
                onClick={togglePasswordVisibility}
              >
                <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
              </span>
            </div>
          </div>
          <div className="input-group">
            <label htmlFor="confirmPassword">Re-enter New Password:</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder="Re-enter new password"
              />
              <span
                className="toggle-password"
                onClick={togglePasswordVisibility}
              >
                <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
              </span>
            </div>
          </div>
          {error && <p className="error-message">{error}</p>}
          {success && <p className="success-message">{success}</p>}
          <button type="submit" className="register-button">
            Reset Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default Resetpw;
